import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth token management
export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    localStorage.setItem('adminToken', token);
  } else {
    delete axios.defaults.headers.common['Authorization'];
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
  }
};

export const getStoredToken = () => localStorage.getItem('adminToken');

export const getStoredUser = () => {
  const user = localStorage.getItem('adminUser');
  return user ? JSON.parse(user) : null;
};

export const setStoredUser = (user) => {
  if (user) {
    localStorage.setItem('adminUser', JSON.stringify(user));
  } else {
    localStorage.removeItem('adminUser');
  }
};

// Initialize auth on app load
export const initAuth = () => {
  const token = getStoredToken();
  if (token) {
    setAuthToken(token);
  }
};

// Auth API calls
export const authApi = {
  login: (email, password) => axios.post(`${API}/admin/login`, { email, password }),
  register: (data) => axios.post(`${API}/admin/register`, data),
  verifyEmail: (token) => axios.post(`${API}/admin/verify-email?token=${token}`),
  getCurrentUser: () => axios.get(`${API}/admin/me`),
  requestPasswordReset: (email) => axios.post(`${API}/admin/request-password-reset`, { email }),
  resetPassword: (token, password) => axios.post(`${API}/admin/reset-password`, { token, new_password: password }),
};
